var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path == '/message')?[_c('message-view')]:[_c('div',{staticClass:"app-bg"},[_c('header-wrap'),_c('router-view'),_c('footer-wrap')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }